import React, { useEffect, useState } from 'react'
import { Route, useHistory } from 'react-router-dom'
import Header from '../Header/Header'
import { assignLanguage } from '../../utils/helpers'
import MainFooter from '../Footer/Footer'
import { useSelector } from 'react-redux'

const FifthLayout = ({ component: Component, ...rest }) => {
    const language = useSelector(state => state?.languageReducer)
    const selectedLanguage = assignLanguage(language?.language)
    console.log(selectedLanguage)
    return (
        <Route {...rest} render={props => <AddMenu selectedLanguage={selectedLanguage} language={language} {...props}
            component={Component}
        />
        } />
    )
}

const AddMenu = ({ component: Component, ...props }) => {
    return (
        <div className='new-main-layout-div '>
            <div>
                <Header {...props} />
                <div className='new-main-component-screen-div'>
                    <Component {...props} />
                </div>
                <MainFooter  {...props}/>
            </div>
        </div>
    )
}

export default FifthLayout